import React from 'react'
import { ComponenteBaseEnlace, ImagenEnlace, PrecioEnlace } from './ComponenteBase'

const DiseñoGlass = ({ 
  enlaces = [], 
  estilosMiniatura = false, 
  esPreview = false,
  configuracion = {}
}) => {
  // Configuración por defecto para el diseño Glass
  const config = {
    transparencia: 'media', // baja | media | alta
    desenfoque: 'medio', // poco | medio | mucho
    bordes: 'redondeado', // cuadrado | redondeado | circular
    ...configuracion
  }

  // Obtener clases de transparencia
  const obtenerClasesTransparencia = () => {
    switch (config.transparencia) {
      case 'baja':
        return 'bg-white/20 backdrop-blur-sm'
      case 'alta':
        return 'bg-white/40 backdrop-blur-xl'
      default:
        return 'bg-white/30 backdrop-blur-md'
    }
  }

  // Obtener clases de bordes
  const obtenerClasesBordes = () => {
    switch (config.bordes) {
      case 'cuadrado':
        return 'rounded-none'
      case 'circular':
        return 'rounded-3xl'
      default:
        return 'rounded-xl'
    }
  }

  // Ajustar para estilos miniatura
  if (estilosMiniatura) {
    return (
      <div className="space-y-1">
        {enlaces.map((enlace, index) => (
          <ComponenteBaseEnlace
            key={enlace.id || index}
            enlace={enlace}
            estilosMiniatura={estilosMiniatura}
            esPreview={esPreview}
            className="enlace-miniatura"
          >
            <div className={`${obtenerClasesTransparencia()} ${obtenerClasesBordes()} border border-white/20 p-2 mb-1 hover:bg-white/40 transition-all duration-300 shadow-lg`}>
              <div className="space-y-1">
                {/* Título arriba */}
                <h3 className="font-semibold text-gray-800 hover:text-blue-600 transition-colors text-xs leading-tight truncate">
                  {enlace.titulo}
                </h3>
                
                {/* Imagen y precio */}
                <div className="flex items-start gap-2">
                  <div className="flex-shrink-0">
                    <ImagenEnlace 
                      enlace={enlace} 
                      estilosMiniatura={estilosMiniatura}
                      mostrarIcono={false}
                    />
                  </div>
                  <div className="flex-1 flex flex-col gap-1">
                    {/* Precio para productos */}
                    {enlace.tipo === 'producto' && (
                      <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                    )}
                  </div>
                </div>
                
                {/* Descripción abajo */}
                {enlace.descripcion && (
                  <p className="text-gray-600 text-xs leading-tight">
                    {enlace.descripcion}
                  </p>
                )}
                
                {/* Precio para enlaces que no son productos */}
                {enlace.tipo !== 'producto' && (
                  <div>
                    <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                  </div>
                )}
              </div>
            </div>
          </ComponenteBaseEnlace>
        ))}
      </div>
    )
  }

  // Diseño normal para desktop
  return (
    <div className="space-y-4">
      {enlaces.map((enlace, index) => (
        <ComponenteBaseEnlace
          key={enlace.id || index}
          enlace={enlace}
          estilosMiniatura={estilosMiniatura}
          esPreview={esPreview}
          className="group"
        >
          <div className={`${obtenerClasesTransparencia()} ${obtenerClasesBordes()} border border-white/20 p-6 hover:bg-white/40 hover:scale-105 transition-all duration-300 shadow-lg group-hover:shadow-xl`}>
            <div className="space-y-4">
              {/* Título arriba */}
              <h3 className="font-bold text-gray-800 group-hover:text-blue-600 transition-colors text-xl">
                {enlace.titulo}
              </h3>
              
              {/* Imagen y precio */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <ImagenEnlace 
                    enlace={enlace} 
                    estilosMiniatura={estilosMiniatura}
                    mostrarIcono={false}
                  />
                </div>
                <div className="flex-1 flex flex-col gap-2">
                  {/* Precio para productos */}
                  {enlace.tipo === 'producto' && (
                    <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                  )}
                </div>
              </div>
              
              {/* Descripción abajo */}
              {enlace.descripcion && (
                <p className="text-gray-600 text-sm">
                  {enlace.descripcion}
                </p>
              )}
              
              {/* Precio para enlaces que no son productos */}
              {enlace.tipo !== 'producto' && (
                <div>
                  <PrecioEnlace enlace={enlace} estilosMiniatura={estilosMiniatura} />
                </div>
              )}
            </div>
          </div>
        </ComponenteBaseEnlace>
      ))}
    </div>
  )
}

export default DiseñoGlass 